import {
  Component,
  ElementRef,
  AfterViewInit,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'lib-signature-pad',
  imports: [],
  templateUrl: './signature-pad.html',
  styleUrl: './signature-pad.scss',
})
export class SignaturePadComponent implements AfterViewInit {
  @ViewChild('canvas', { static: true })
  canvasRef!: ElementRef<HTMLCanvasElement>;
  private ctx!: CanvasRenderingContext2D;
  private signaturePad!: any;
  isError = false;

  constructor(public dialogRef: MatDialogRef<SignaturePadComponent>) {}

  ngAfterViewInit(): void {
    const canvas = this.canvasRef.nativeElement;
    // canvas.width = canvas.offsetWidth || 400;
    // canvas.height = canvas.height || 200;

    // this.signaturePad = new SignaturePad(canvas, {
    //   penColor: 'rgb(0, 0, 0)',
    // });
    setTimeout(() => {
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;

      const context = canvas.getContext('2d');
      if (context) {
        this.ctx = context;
        this.ctx.lineWidth = 2;
        this.ctx.lineCap = 'round';
        this.ctx.strokeStyle = '#000000';
      }
    }, 50);
  }
  private isDrawing = false;
  startDrawing(event: MouseEvent | TouchEvent) {
    this.isDrawing = true;
    const pos = this.getCursorPosition(event);
    this.ctx.beginPath();
    this.ctx.moveTo(pos.x, pos.y);
  }

  draw(event: MouseEvent | TouchEvent) {
    if (!this.isDrawing) return;
    const pos = this.getCursorPosition(event);
    this.ctx.lineTo(pos.x, pos.y);
    this.ctx.stroke();
  }

  stopDrawing() {
    this.isDrawing = false;
    this.ctx.beginPath();
  }

  private getCursorPosition(event: MouseEvent | TouchEvent): {
    x: number;
    y: number;
  } {
    const canvas = this.canvasRef.nativeElement;
    const rect = canvas.getBoundingClientRect();

    const clientX =
      'touches' in event
        ? event.touches[0].clientX
        : (event as MouseEvent).clientX;
    const clientY =
      'touches' in event
        ? event.touches[0].clientY
        : (event as MouseEvent).clientY;

    // Recalculate scaling live on every move event
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;

    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY,
    };
  }

  clearPad(): void {
    this.signaturePad?.clear();
    this.isError = false;
  }

  savePad() {
    const canvas = this.canvasRef?.nativeElement;
    if (!canvas) return;

    // Optional: Check if canvas is completely blank before saving
    if (this.isCanvasBlank(canvas)) {
      console.warn('Signature pad is empty');
      return;
    }

    const dataURL = canvas.toDataURL('image/png');
    // Pass dataURL back to your parent component or dialog result
    this.dialogRef.close(dataURL);
  }

  // Helper to check if canvas has drawing content
  private isCanvasBlank(canvas: HTMLCanvasElement): boolean {
    const blank = document.createElement('canvas');
    blank.width = canvas.width;
    blank.height = canvas.height;
    return canvas.toDataURL() === blank.toDataURL();
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
